module.exports = __webpack_public_path__ + "static/social-4-e5e788f2839f101d678b8332697b0a4b.png";